import React from 'react';
import { Typography, ButtonBase, Icon } from '@material-ui/core';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { PageHeader } from '../../../../components';
import { filterVehiclesAdmin } from '../../../../actions/vehicles';

const StyledTypography = styled(Typography)`
  && {
    font-weight: 500;
    font-size: 16px;
    padding: 23px 13px;
  }
`;

const Header = ({ refreshList, perPage, setPage }) => (
  <PageHeader>
    <StyledTypography variant="title">Manage Vehicles</StyledTypography>
    <span className="flex-grow" />
    <ButtonBase
      onClick={() => {
        setPage(1);
        refreshList({ params: { limit: perPage, offset: 1 } });
        setPage(2);
      }}
    >
      <Icon>refresh</Icon>
    </ButtonBase>
  </PageHeader>
);

const mapDispatchToProps = dispatch => ({
  refreshList: data => dispatch(filterVehiclesAdmin(data).request)
});

export default connect(
  state => ({
    auctionStatus: state.vehicles.auctionStatus
  }),
  mapDispatchToProps
)(Header);
